import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
  background: #000; /* Set background to black */
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
    height: 70px;
    margin-top: -70px;
  }

  @media screen and (max-width: 480px) {
    height: 60px;
    margin-top: -60px;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  z-index: 1;
  width: 100%;
  max-width: 1700px;
  padding: 0 24px;

  @media screen and (max-width: 960px) {
    height: 70px;
  }

  @media screen and (max-width: 480px) {
    height: 60px;
    padding: 0 15px;
  }
`;

export const NavLogo = styled(LinkR)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  text-decoration: none;
  gap: 10px;

  img {
    transition: all 0.2s ease-in-out;
  }

  @media screen and (max-width: 768px) {
    img:nth-child(2) {
      width: 120px !important;
    }
  }

  @media screen and (max-width: 480px) {
    img:nth-child(1) {
      width: 30px !important;
    }
    img:nth-child(2) {
      width: 100px !important;
    }
  }
`;

export const MenuIcon = styled.div`
  display: none;

  @media screen and (max-width: 1000px) {
    display: block;
    position: absolute;
    top: -10px;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
    z-index: 999;
  }

  @media screen and (max-width: 480px) {
    transform: translate(-80%, 60%);
    font-size: 1.5rem;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  padding-top: 15px;

  @media screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column !important; /* Override inline styles for mobile */
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    right: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
    opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
    visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
    background: #000;
    transition: all 0.3s ease-in-out;
    z-index: 990;
    padding-top: 80px;
    justify-content: center;
  }
`;

export const NavItem = styled.li`
  height: 80px;

  @media screen and (max-width: 1000px) {
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const NavLink = styled(LinkS)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 2rem;
  font-size: 20px;
  height: 100%;
  cursor: pointer;
  font-weight: normal;

  &.active {
    border-bottom: 3px solid #18e68e;
    color: #18e68e;
  }

  @media screen and (max-width: 1200px) {
    padding: 0 1.5rem;
    font-size: 18px;
  }

  @media screen and (max-width: 1000px) {
    padding: 1.5rem;
    font-size: 22px;
    width: 100%;
    display: flex;
    justify-content: center;

    &.active {
      border-bottom: none;
      color: #18e68e;
    }
  }

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 1000px) {
    display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
    justify-content: center;
    width: 100%;
    margin: 20px 0;
  }
`;

export const TranslateBtn = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 1000px) {
    display: ${({ isOpen }) => (isOpen ? "none" : "flex")};
    margin-right: 55px;
  }

  @media screen and (max-width: 768px) {
    margin-right: 55px;
  }

  @media screen and (max-width: 480px) {
    margin-right: 40px;
  }
`;

export const NavBtnLink = styled(LinkR)`
  border-radius: 50px;
  background: #18e68e;
  white-space: nowrap;
  padding: 10px 22px;
  color: #010606;
  font-size: 15px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  font-weight: normal;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
  }

  @media screen and (max-width: 1024px) {
    padding: 6px 14px;
    font-size: 10px;
  }

  @media screen and (max-width: 480px) {
    padding: 6px 14px;
    font-size: 12px;
  }
`;
